/** @format */

import {AccountDesignsOrdersContext} from 'frontier/account/components/context/AccountDesignsOrdersContext';
import {validateOrderWithErrors} from 'frontier/ds/quoter/functions/validate';
import DimensionValidator from 'frontier/utilities/dimension_validator';
import {DuplicateOrderButton} from '../../shared/duplicate_order_button';
import {ReorderDesignModal} from './reorder_design_modal';
import useDesignReorder from './use_design_reorder';
import {IfElse, If} from 'frontier-utilities';
import React, {useContext} from 'react';
import Moment from 'moment/moment';
import {
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    isSubstrateBackordered,
    PRODUCT_TYPE_LABEL,
    CARTON_SUBSTRATES,
    SIZE_STATUS_TRASH,
    SUBSTRATES
} from 'frontier-constants';

export const ReorderDesign = props => {
    const designCtx = useContext(AccountDesignsOrdersContext);

    const {
        reorderFormData: formData,
        toggleIsShowingReorderForm,
        ...restOfDesignReorder
    } = useDesignReorder(designCtx.design.id);

    const {isComplete: isReorderPossible} = validateOrderWithErrors(designCtx.order);

    const isBackordered =
        designCtx.order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN
            ? false
            : isSubstrateBackordered(designCtx.order.substrate_id);
    const isTrashed = designCtx.size.status_id === SIZE_STATUS_TRASH;
    const dmv = new DimensionValidator({
        width: designCtx.size.width,
        length: designCtx.size.length,
        depth: designCtx.size.depth,
        shapeId: designCtx.size.shape_id,
        productTypeId: designCtx.order.product_type_id
    });
    const isOversize = !dmv.isValidSize();

    const productBackOrderedLabel =
        designCtx.order.product_type_id === PRODUCT_TYPE_LABEL
            ? SUBSTRATES.find(s => s.id === designCtx.order.substrate_id)?.label
            : CARTON_SUBSTRATES.find(s => s.id === designCtx.order.substrate_id)?.label;

    const materialBackOrderedUntil = Moment(
        databaseConstants.backorderedSubstrates.find(
            ({id: backorderedId}) => backorderedId === parseInt(designCtx.order.substrate_id)
        )?.expected_instock_date
    )
        .utc()
        .format('MM/DD');

    const isDesignArchived = designCtx.design.is_archived;

    return (
        <>
            {/* action button */}
            <div>
                <If
                    condition={
                        !designCtx.order.has_variable_data &&
                        isReorderPossible &&
                        !isDesignArchived &&
                        !isTrashed
                    }>
                    <button
                        className="p-0 m-0 color-accent-primary d-flex align-items-center justify-content-start"
                        onClick={toggleIsShowingReorderForm}>
                        <i className="fa fa-clock-rotate-left me-2" />
                        <u>Re-order</u>
                    </button>
                </If>
                <If condition={isBackordered}>
                    <div className="alert alert-danger mt-3">
                        {productBackOrderedLabel} is backordered until {materialBackOrderedUntil}
                    </div>
                </If>
                <If condition={isTrashed}>
                    <>
                        <p className="color-alert-negative m-0 p-0">
                            We no longer stock this size.
                        </p>
                        {!isOversize && <DuplicateOrderButton id={designCtx.order.id} />}
                    </>
                </If>
                <If condition={designCtx.order.has_variable_data}>
                    <p className="color-alert-negative m-0 p-0">
                        We no longer offer variable data.
                    </p>
                </If>
            </div>

            {/* modal */}
            <ReorderDesignModal
                {...{toggleIsShowingReorderForm, formData, order: designCtx.order}}
                {...restOfDesignReorder}
            />
        </>
    );
};
